import DrawerActions from 'components/DrawerActions';
import { Form, Formik, FormikProps, FormikValues } from 'formik';

import { FormContainerProps } from './types';

export default function FormContainer<T extends FormikValues>({
  initialValues,
  onSubmit,
  validationSchema,
  formRef,
  buttons,
  children
}: FormContainerProps<T>) {
  return (
    <div>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        innerRef={formRef}
        enableReinitialize
      >
        {(props: FormikProps<T>) => (
          <Form>
            {children && children(props)}
            {buttons && <DrawerActions>{buttons(props)}</DrawerActions>}
          </Form>
        )}
      </Formik>
    </div>
  );
}
